/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime.js";
import type { ApplicationSummary } from "./ApplicationSummary.js";
import {
  ApplicationSummaryFromJSON,
  ApplicationSummaryFromJSONTyped,
  ApplicationSummaryToJSON,
} from "./ApplicationSummary.js";
import type { SearchResultMeta } from "./SearchResultMeta.js";
import {
  SearchResultMetaFromJSON,
  SearchResultMetaFromJSONTyped,
  SearchResultMetaToJSON,
} from "./SearchResultMeta.js";

/**
 *
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
  /**
   *
   * @type {SearchResultMeta}
   * @memberof SearchResult
   */
  meta: SearchResultMeta;
  /**
   *
   * @type {ApplicationSummary}
   * @memberof SearchResult
   */
  data: ApplicationSummary;
}

/**
 * Check if a given object implements the SearchResult interface.
 */
export function instanceOfSearchResult(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "meta" in value;
  isInstance = isInstance && "data" in value;

  return isInstance;
}

export function SearchResultFromJSON(json: any): SearchResult {
  return SearchResultFromJSONTyped(json, false);
}

export function SearchResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SearchResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    meta: SearchResultMetaFromJSON(json["meta"]),
    data: ApplicationSummaryFromJSON(json["data"]),
  };
}

export function SearchResultToJSON(value?: SearchResult | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    meta: SearchResultMetaToJSON(value.meta),
    data: ApplicationSummaryToJSON(value.data),
  };
}
